export default "__VITE_ASSET__ZdAzPzkX__"